import type { GlobalThisWithLocalDevContext } from './GlobalThisWithLocalDevContext.tsx';

export default function getLocalUrlOverride(): string | undefined {
	// oxlint-disable-next-line typescript/consistent-type-assertions
	return (globalThis as GlobalThisWithLocalDevContext).localDevContext?.LOCAL_URL_OVERRIDE;
}
